import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class VariantDescriptionComponent extends Component {
  requiredRefs = ['descriptionItems'];
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();
    this.#render(this.dataset.currentVariantId);

    const target = this.closest('.shopify-section, dialog, product-card') || document;
    target.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate, { signal: this.#abortController.signal });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#render(this.dataset.currentVariantId);
  }

  #onVariantUpdate = (event) => {
    const productId = event.detail?.data?.productId;
    if (productId && this.dataset.productId && productId !== this.dataset.productId) return;

    const variantId = event.detail?.resource?.id;
    if (variantId) {
      this.dataset.currentVariantId = String(variantId);
    }
    this.#render(variantId);
  };

  #render(variantId) {
    const items = Array.isArray(this.refs.descriptionItems) ? this.refs.descriptionItems : [this.refs.descriptionItems];
    let hasVisibleItem = false;

    for (const item of items) {
      const matches = variantId && item.dataset.variantId === String(variantId) && item.innerHTML.trim() !== '';
      item.hidden = !matches;
      if (matches) hasVisibleItem = true;
    }

    this.hidden = !hasVisibleItem;
  }
}

if (!customElements.get('variant-description-component')) {
  customElements.define('variant-description-component', VariantDescriptionComponent);
}
